import { I18n } from '../../i18n/mx-internationalization';
import { ConfigService } from './mx-config-service';
import { IWindowService } from 'angular';
import { ApiError, HttpErrorResponse } from '../../Types';

export class ErrorFactory {
	static $inject = ['mx.internationalization', 'mx.shell.Config', '$window'];

	constructor(
		private readonly i18n: I18n,
		private readonly configService: ConfigService,
		private readonly $window: IWindowService
	) {}

	createApiError(responseValue: string | HttpErrorResponse): ApiError {
		let response: HttpErrorResponse;
		if (typeof responseValue === 'string') {
			let data: string;
			try {
				data = JSON.parse(responseValue);
			} catch {
				data = '';
			}
			response = { data: data } as HttpErrorResponse;
		} else {
			response = responseValue;
		}
		return new ApiError(response, this.i18n, this.$window, this.configService);
	}
}
